/**
 * The column types for the requests processed disclosure stats table
 */
export enum RequestsProcessedDisclosureStatsTableHeaders {
  Received = 'received',
  Processed = 'processed',
  Denied = 'denied',
  MedianNumberOfDays = 'medianNumberOfDays',
}
